import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { WebAppSharedModule } from '../../shared';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslatePipeModule } from './../../../language/language.module';

import {
    ItemService,
    ItemPopupService,
    ItemPreviewPopupComponent,
    // invoiceHtmlPopupRoute,
    ItemPreviewInvoiceTemplateComponent,
} from './';

const ENTITY_STATES = [
    // ...invoiceHtmlPopupRoute,
];

@NgModule({
    imports: [
        WebAppSharedModule,
        CommonModule,
        FormsModule,
        TranslatePipeModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        ItemPreviewPopupComponent,
        ItemPreviewInvoiceTemplateComponent,
    ],
    entryComponents: [
        ItemPreviewPopupComponent,
        ItemPreviewInvoiceTemplateComponent,
    ],
    providers: [
        ItemService,
        ItemPopupService,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class WebAppItemModule {}
